// Packages
import { Box } from '@mui/material';

// Icon
import { ReactComponent as WiredIcon } from "assets/images/icons/icn_dashboard_wired_status.svg";
import { ReactComponent as WiredNoStateIcon } from "assets/images/icons/icn_no_status.svg";

export const HeaderIcon = ({
  state,
}) => {

  return (
    <Box
      sx={{
        position: "relative",
        width: 60,
        height: 60,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <WiredIcon
        style={{
          width: "100%",
          height: "100%",
          position: "absolute",
          zIndex: 1,
        }}
      />
      {
        state === "-" && (
          <WiredNoStateIcon
            style={{
              position: "absolute",
              zIndex: 3,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          />
        )
      }
      {
        state && state !== "-" && (
          <Box
            sx={{
              position: "absolute",
              zIndex: 4,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            { state }
          </Box>
        )
      }
    </Box>
  )
}